export interface IBaseUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string | null;
  dateOfBirth?: string;
  gender?: Gender;
}

export const genders = ["Male", "Female" /*, "Other"*/] as const;
export type Gender = typeof genders[number];
